// src/i18n-dom.js
// Translates static HTML elements marked with data-i18n attributes.
// Runs on DOMContentLoaded and re-applies on every locale change.
import { t, onLocaleChange } from './i18n.js';

function applyAll() {
  // text content
  for (const el of document.querySelectorAll('[data-i18n]')) {
    const key = el.dataset.i18n;
    // Keys starting with 'html:' set innerHTML, not textContent
    if (key.startsWith('html:')) continue;
    el.textContent = t(key);
  }
  // innerHTML (for strings that contain <strong> etc.).
  // data-i18n-link passes the link URL as {0} into the string.
  for (const el of document.querySelectorAll('[data-i18n^="html:"]')) {
    const key = el.dataset.i18n.slice('html:'.length);
    const link = el.dataset.i18nLink || '';
    el.innerHTML = t(key, link);
  }
  // title attribute
  for (const el of document.querySelectorAll('[data-i18n-attr-title]')) {
    el.title = t(el.dataset.i18nAttrTitle);
  }
  // document title
  document.title = t('app.title');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', applyAll);
} else {
  applyAll();
}

onLocaleChange(applyAll);
